<template>
  <el-card class="v_leave_msg">
    <div class="g-flex"  slot="header">
      <span>留言列表</span>
    </div>

    <!-- 搜索 -->
    <el-form :inline="true" size="mini" :model="query">
      <el-form-item>
        <el-select slot="label" v-model="query.search_key" placeholder="查询">
          <el-option label="唯一标识" value="client_id"></el-option>
          <el-option label="姓名" value="name"></el-option>
          <el-option label="手机号" value="mobile"></el-option>
          <el-option label="邮箱" value="email"></el-option>
          <el-option label="ip" value="ip"></el-option>
          <el-option label="ip地址" value="ip_address"></el-option>
        </el-select>
        <el-row>
          <el-col :span="18">
            <el-input v-model="query.search_val" @keyup.enter.native="getList()" @clear="getList()" placeholder="请输入查找内容" clearable></el-input>
          </el-col>
          <el-col :span="5" :offset="1">
            <el-button type="primary" @click="getList()">查询</el-button>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="登录时间">
          <el-date-picker v-model="query.date_time" @change="getList()" type="datetimerange"
                          :default-time="['00:00:00', '23:59:59']" range-separator="至" start-placeholder="开始日期"
                          end-placeholder="结束日期">
          </el-date-picker>
      </el-form-item>
    </el-form>

    <!-- 表格 -->
    <el-table stripe size="mini" v-loading="table.loading" :data="table.rows" border>
      <el-table-column prop="client_id" label="唯一标识" width="100" :show-overflow-tooltip="true"/>
      <el-table-column prop="name" label="留言人" width="100" :show-overflow-tooltip="true"/>
      <el-table-column prop="content" label="留言内容" :show-overflow-tooltip="true"/>
      <el-table-column prop="qq" label="qq号" :show-overflow-tooltip="true"/>
      <el-table-column prop="mobile" label="手机号" :show-overflow-tooltip="true"/>
      <el-table-column prop="ip" label="ip" width="100" :show-overflow-tooltip="true"/>
      <el-table-column prop="ip_address" label="ip地址" :show-overflow-tooltip="true"/>
      <el-table-column label="创建时间" width="140" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{formatDate(scope.row.create_time, 'yyyy-MM-dd hh:mm')}}</span>
        </template>
      </el-table-column>
      <el-table-column label="登录时间" width="140" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{formatDate(scope.row.login_time, 'yyyy-MM-dd hh:mm')}}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.status==0" class="g-red">离线</span>
            <span v-else-if="scope.row.status==1" class="g-green">在线</span>
          </template>
      </el-table-column>
      <el-table-column v-if="auth.delEnt"  label="操作" width="80">
        <template slot-scope="scope">
          <el-button v-if="auth.delEnt" size="mini" type="danger" @click="del(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :page-sizes="[15, 30, 60, 100]" :page-size="query.limit" :total="table.total" :current-page.sync="query.page" @current-change="getList(false)" @size-change="sizeChange" small hide-on-single-page background layout="total, sizes, prev, pager, next, jumper"></el-pagination>
  
  </el-card>
</template>

<script>
  import { formatDate } from '@/utils/index.js';
  import { apiGetLeaveList, apiDelLeave } from '@/utils/api.js'
  export default {
    data() {
      return {
        auth:{
          delEnt: this.$global.ApiList.includes(43),
        },

        query: { search_key: 'client_id',search_val: '', date_time: [], page:1, limit: 15 },

        table:{ loading:false, total:0, rows:[] },

        formData: {},
      }
    },
    created() {
      this.getList()
    },
    methods: {
      formatDate,

      async getList(pageInit = true) {
        if (pageInit) this.query.page = 1
        this.table.loading = true
        const { success, data } = await apiGetLeaveList(this.query)
        this.table.loading = false
        this.table.rows = data.rows
        this.table.total = data.total
        if(!success) return
      },

      //每页数量改变
      sizeChange(limit) {
        this.query.limit = limit
        this.getList()
      },
      
      // 点击删除
       del({ id }) {
        this.$confirm('将永久删除该留言, 是否继续?', '删除提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          this.table.loading = true
          const { success, data } = await apiDelLeave({ id: id })
          this.table.loading = false
          if(!success) return
          this.$message.success(data.msg)
          this.getList()
        }).catch(()=>{})
      }, 
    }
  }
</script>

<style lang="scss">
</style>